import React from 'react';
import { isEmpty } from 'lodash';
import { Link } from 'react-router-dom';

import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import SearchIcon from '@material-ui/icons/Search';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';

import ACButton from '../../atoms/ACButton';
import { getInternalBaseUrl } from '../../common/global.js';
import styles from './ProviderList.module.scss';

export default class ProviderList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.onCreateProvider = this.onCreateProvider.bind(this);
    this.onClickProvider = this.onClickProvider.bind(this);

    this.renderProvider = this.renderProvider.bind(this);
    this.renderProviders = this.renderProviders.bind(this);
  }

  onCreateProvider() {
    this.props.onCreateProviderFunc();
  }

  onClickProvider(providerId) {
    const ps = this.props.providers.filter((p) => p.id === providerId);

    if (ps && ps.length > 0) {
      const p = ps[0];

      // extract media to ease later manipulation
      const medias = p.medias || [];
      let media = p.media || { type: 'image', url: '' };
      if (isEmpty(media.url) && !isEmpty(medias)) media = medias[medias.length - 1]; // Pick last element as most probable the latest
      p.media = media;
      this.props.onSelectProviderFunc(p);
    }
  }

  renderProvider = (prov) => {
    const provider = this.props.provider;
    if (isEmpty(prov)) return;

    const id = prov.id || '';
    const phone = prov.phone || {};
    const phoneNumber = phone.number || '';
    const email = prov.email || {};
    const emailAddress = email.address || '';
    let gotToProviderUrl = getInternalBaseUrl().providers + '?id=' + id;

    let s = [styles.providerLististItem];
    if (provider && provider.id === prov.id) {
      s.push(styles.selected);
    }

    return (
      <ListItem className={s.join(' ')} key={prov.id + '-key'}>
        <div style={{ width: '100%' }}>
          <Link
            to={gotToProviderUrl}
            style={{ textDecoration: 'none', color: 'inherit', width: '100%', padding: '10px' }}
            onClick={() => this.onClickProvider(prov.id)}
          >
            <div className={styles.providerName}>{prov.name}</div>
            <div>{emailAddress}</div>
            <div>{phoneNumber}</div>
          </Link>
        </div>
      </ListItem>
    );
  };

  renderProviders = () => {
    const providers = this.props.providers;
    if (isEmpty(providers)) return;

    return providers.map((p) => {
      return this.renderProvider(p);
    });
  };

  renderSearchBox() {
    return (
      <TextField
        id="simple-start-adornment"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
        placeholder="Search"
        className={styles.search}
        value={this.props.searchText}
        onChange={(e) => this.props.onChangeSearchTextFunc(e)}
      />
    );
  }

  render() {
    return (
      <div className={styles.root}>
        <div className={styles.top}>
          <div className={styles.header}>
            Provider List
            <ACButton
              text={'Add'}
              icon={<AddCircleOutlineIcon />}
              onClickFunc={() => this.onCreateProvider()}
            />
          </div>
          {this.renderSearchBox()}
        </div>
        <div className={styles.bottom}>
          <List className={styles.providerList}>{this.renderProviders()}</List>
        </div>
      </div>
    );
  }
}
